<template>
	<customizer-section :title="optionType.type_name" :style="{ display: optionList.length > 0 ? 'block' : 'block' }">
		<template v-slot:icon>
			<div :class="`option-icon option-${optionType.system_name}`" />
		</template>

		<div class="customizer-options">
			<ul class="product-option-list">
				<li v-for="option in optionList" :key="option.id">
					<product-option :option="option" :disabled="!canSelectOption(option)" />
				</li>
			</ul>
		</div>
	</customizer-section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import CustomizerSection from './CustomizerSection.vue';
import ProductOption from './ProductOption.vue';

import { canSelectOption } from '../options';

export default {
	components: { CustomizerSection, ProductOption },

	props: {
		optionType: { type: Object, required: true },
	},

	computed: {
		...mapGetters('customizer', ['allSelectedOptions']),
		...mapState({
			optionTypes: state => state.shell.productOptionTypes,
			optionsByType: state => state.customizer.optionsByType,
			options: state => state.customizer.options,
			cartItem: state => state.customizer.cartItem,
		}),

		// get options for the current type
		optionList()
		{
			// return an empty array if there are no options
			if (!this.optionsByType[this.optionType.id])
				return [];

			// otherwise return options
			return this.optionsByType[this.optionType.id].map(id => this.options[id]);//.filter(o => this.canSelectOption(o));
		}
	},

	methods: {
		canSelectOption(option)
		{
			//var type = this.optionTypes[option.product_option_type_id];
			var width = parseInt(this.cartItem.width.whole, 10) || 0; //+ parseFloat(this.cartItem.width.fractional);
			var height = parseInt(this.cartItem.height.whole, 10) || 0; // + parseFloat(this.cartItem.height.fractional);
		
			return canSelectOption(option, width, height, this.allSelectedOptions);
		}
	}
}
</script>